import { setGetListPaymentSystemAction } from '../action';
import { getListPaymentSystem } from '../api/getListPaymentSystem';

const setGetListPaymentSystem = (params ) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListPaymentSystem(params);

            if (data.status === 'success') {
                dispatch(setGetListPaymentSystemAction(data.data));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListPaymentSystem
}